<div class="central-dialog-backdrop" *ngIf="aberto" (click)="onFechar()"></div>

<section class="central-dialog" *ngIf="aberto" (click)="$event.stopPropagation()">
  <header class="central-dialog-header">
    <div>
      <h2>{{ etapaEnderecos ? 'Escolher endereço do cliente' : 'Selecionar cliente da Central' }}</h2>
    </div>

    <button type="button" class="central-dialog-close" (click)="onFechar()" [disabled]="preparando" aria-label="Fechar">
      <span>Esc</span>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </header>

  <div class="central-dialog-search" *ngIf="!etapaEnderecos">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="11" cy="11" r="8"/>
      <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
    <input
      #buscaCentralInput
      type="text"
      [ngModel]="termoBusca"
      (ngModelChange)="onTermoBuscaChange($event)"
      placeholder="Digite telefone ou nome do cliente"
      [disabled]="preparando"
      appAutoFocus>
    <button type="button" (click)="onBuscar()" [disabled]="!podeBuscar">
      {{ buscando ? 'Buscando...' : 'Buscar' }}
    </button>
  </div>

  <div class="central-dialog-error" *ngIf="erro">
    {{ erro }}
  </div>

  <div class="central-selected-client" *ngIf="etapaEnderecos">
    <span class="central-client-avatar is-selected">{{ getClientInitial(clienteSelecionado) }}</span>
    <div class="central-selected-client-main">
      <strong>{{ clienteSelecionado?.nome }}</strong>
      <small class="central-client-phone">
        <i class="fab fa-whatsapp" aria-hidden="true"></i>
        <span>{{ clienteSelecionado?.telefone | tel:(clienteSelecionado?.codigoPais || '+55') }}</span>
      </small>
    </div>
    <div class="central-selected-client-store">
      <span>Cliente da loja</span>
      <strong>{{ getLojaOrigem(clienteSelecionado) }}</strong>
    </div>
    <button type="button" class="central-change-client-btn" (click)="onTrocarCliente()" [disabled]="preparando">
      <span>F4</span>
      Trocar cliente
    </button>
  </div>

  <div class="central-dialog-body" [class.is-address-step]="etapaEnderecos">
    <main class="central-dialog-main">
      <ng-container *ngIf="!etapaEnderecos; else enderecosTpl">
        <div class="central-results-head">
          <strong>Clientes encontrados</strong>
          <span *ngIf="totalClientes">{{ totalClientes }} resultado(s)</span>
        </div>

        <div class="central-shortcuts" *ngIf="totalClientes">
          <span><kbd>F4</kbd> busca</span>
          <span><kbd>↑</kbd><kbd>↓</kbd> navegar</span>
          <span><kbd>Enter</kbd> selecionar</span>
          <span><kbd>Alt</kbd> + <kbd>1</kbd>-<kbd>9</kbd> rápido</span>
        </div>

        <div class="central-empty-state" *ngIf="!buscando && !totalClientes">
          <strong>Comece pela busca do cliente</strong>
          <span>Use telefone ou nome. Os resultados aparecem separados pela loja onde o cadastro foi encontrado.</span>
        </div>

        <div class="central-empty-state" *ngIf="buscando && !totalClientes">
          <strong>Buscando clientes...</strong>
          <span>Estamos consultando as lojas participantes da Central.</span>
        </div>

        <div class="central-client-groups" *ngIf="totalClientes">
          <div class="central-client-group" *ngFor="let grupo of clientesAgrupados; let grupoIndex = index; trackBy: trackByGrupo">
            <div class="central-client-group-title">
              {{ grupo.loja?.nome || 'Loja' }}
            </div>

            <button type="button"
                    #clienteCard
                    class="central-client-card"
                    *ngFor="let cliente of grupo.clientes; let clienteIndex = index; trackBy: trackByCliente"
                    [class.is-keyboard-selected]="isClienteAtivo(getClienteIndiceGlobal(grupoIndex, clienteIndex))"
                    (click)="onSelecionarClientePorClique(cliente, getClienteIndiceGlobal(grupoIndex, clienteIndex))">
              <span class="central-client-shortcut" *ngIf="getClienteAtalho(getClienteIndiceGlobal(grupoIndex, clienteIndex))">
                Alt+{{ getClienteAtalho(getClienteIndiceGlobal(grupoIndex, clienteIndex)) }}
              </span>
              <span class="central-client-avatar">{{ getClientInitial(cliente) }}</span>
              <span class="central-client-info">
                <strong>{{ cliente.nome }}</strong>
                <small class="central-client-phone">
                  <i class="fab fa-whatsapp" aria-hidden="true"></i>
                  <span>{{ cliente.telefone | tel:(cliente.codigoPais || '+55') }}</span>
                </small>
              </span>
              <span class="central-client-meta">
                {{ cliente.qtdePedidos || 0 }} pedido(s)
              </span>
            </button>
          </div>
        </div>
      </ng-container>

      <ng-template #enderecosTpl>
        <div class="central-results-head">
          <strong>Endereços cadastrados</strong>
          <span>{{ enderecos?.length || 0 }} endereço(s)</span>
        </div>

        <div class="central-shortcuts" *ngIf="enderecos?.length">
          <span><kbd>↑</kbd><kbd>↓</kbd> navegar</span>
          <span><kbd>Enter</kbd> usar endereço</span>
          <span><kbd>Alt</kbd> + <kbd>1</kbd>-<kbd>9</kbd> rápido</span>
          <span><kbd>F4</kbd> trocar cliente</span>
        </div>

        <div class="central-empty-state" *ngIf="!enderecos?.length">
          <strong>Cliente sem endereço cadastrado</strong>
          <span>Para delivery, escolha outro cliente ou cadastre o endereço antes de continuar.</span>
        </div>

        <div class="central-address-list" *ngIf="enderecos?.length">
          <button type="button"
                  #enderecoCard
                  class="central-address-card"
                  *ngFor="let endereco of enderecos; let i = index; trackBy: trackByEndereco"
                  [class.is-suggested]="i === 0 && !enderecoSelecionado"
                  [class.is-keyboard-selected]="isEnderecoAtivo(i)"
                  [class.is-selected]="(enderecoSelecionado?.enderecoId || enderecoSelecionado?.id) === (endereco?.enderecoId || endereco?.id)"
                  (click)="onSelecionarEnderecoPorClique(endereco, i)"
                  [disabled]="preparando">
            <span class="central-address-shortcut" *ngIf="getEnderecoAtalho(i)">
              Alt+{{ getEnderecoAtalho(i) }}
            </span>
            <span class="central-address-pin" [class.is-blue]="i % 3 === 1" [class.is-purple]="i % 3 === 2">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </span>
            <span class="central-address-info">
              <strong>{{ getEnderecoPrincipal(endereco) }}</strong>
              <small>{{ getEnderecoSecundario(endereco) }}</small>
            </span>
            <span class="central-address-tag"
                  *ngIf="getEnderecoTipoLabel(endereco)"
                  [ngClass]="getEnderecoTipoClasse(endereco)">
              {{ getEnderecoTipoLabel(endereco) }}
            </span>
            <span class="central-address-action">
              {{ preparando ? 'Aguarde' : 'Usar este endereço' }}
            </span>
            <span class="central-address-chevron" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </span>
          </button>
        </div>
      </ng-template>
    </main>

    <aside class="central-dialog-aside">
      <ng-container *ngIf="!etapaEnderecos">
        <div class="central-step-card" [class.is-done]="clienteSelecionado">
        <span class="central-step-index">1</span>
        <div>
          <strong>Cliente</strong>
          <small>{{ clienteSelecionado?.nome || 'Selecione o cadastro do cliente' }}</small>
        </div>
      </div>

      <div class="central-step-card" [class.is-done]="enderecoSelecionado" [class.is-active]="clienteSelecionado && !enderecoSelecionado">
        <span class="central-step-index">2</span>
        <div>
          <strong>Endereço</strong>
          <small>{{ enderecoSelecionado ? getEnderecoPrincipal(enderecoSelecionado) : 'Escolha o endereço de delivery' }}</small>
        </div>
      </div>
      </ng-container>

      <div class="central-destination-card" [class.is-ready]="lojaDestino">
        <span>Loja destino</span>
        <div class="central-destination-visual">
          <span class="central-destination-store">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9">
              <path d="M3 9l1.2-5h15.6L21 9"/>
              <path d="M5 9v10h14V9"/>
              <path d="M9 19v-6h6v6"/>
              <path d="M3 9h18"/>
            </svg>
          </span>
          <svg class="central-destination-route" width="76" height="44" viewBox="0 0 76 44" fill="none">
            <path d="M6 10c18 0 8 24 28 24 18 0 13-21 35-21" stroke="#9aa9c0" stroke-width="3" stroke-linecap="round" stroke-dasharray="3 9"/>
          </svg>
          <span class="central-destination-pin">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
          </span>
        </div>
        <strong *ngIf="!lojaDestino && !preparando">Aguardando endereço</strong>
        <strong *ngIf="preparando && !lojaDestino">Resolvendo loja...</strong>
        <strong *ngIf="lojaDestino">{{ lojaDestino.nome }}</strong>
        <small *ngIf="roteamento?.motivo">{{ roteamento.motivo }}</small>
        <small *ngIf="!roteamento?.motivo">A loja será definida automaticamente pelo bairro.</small>
      </div>

      <div class="central-dialog-hint" *ngIf="!etapaEnderecos">
        <strong>Depois da loja resolvida</strong>
        <span>O cardápio, carrinho e pagamento passam a usar a unidade destino.</span>
      </div>
    </aside>
  </div>
</section>
